export default __webpack_public_path__ + "static/media/soft-launch.41e70214.svg";